import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import config from '../../config';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Banner = () => {
    const [entityNames, setEntityNames] = useState([]);
    const [stateNames, setStateNames] = useState([]);
    const [selectedEntity, setSelectedEntity] = useState('');
    const [selectedEntityId, setSelectedEntityId] = useState('');
    const [selectedState, setSelectedState] = useState('');
    const [selectedStateId, setSelectedStateId] = useState('');
    const [stateOfficialAddress, setStateOfficialAddress] = useState('');
    const comparisonRef = useRef(null);

    // const bannerImageUrl = useMemo(() => 'images/banner.jpg', []);
    const bannerImageUrl = '/images/banner.webp';
    
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = bannerImageUrl;
        document.head.appendChild(link);

        const fetchData = async () => {
            try {
                const [entityRes, stateRes] = await Promise.all([
                    fetch(`${config.baseUrl}/entity/list`),
                    fetch(`${config.baseUrl}/state/list`)
                ]);

                const entityData = await entityRes.json();
                const stateData = await stateRes.json();

                if (entityData.status === 'success') {
                    setEntityNames(entityData.data);
                }
                if (stateData.status === 'success') {
                    setStateNames(stateData.data);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();

        return () => {
            const links = document.querySelectorAll(`link[href="${bannerImageUrl}"]`);
            links.forEach(link => link.remove());
        };
    }, [bannerImageUrl]);

    const handleViewPackagesClick = useCallback((e) => {
        e.preventDefault();
        comparisonRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, []);

    const handleStateChange = useCallback((e) => {
        const stateName = e.target.value;
        const selected = stateNames.find(st => st.state_name === stateName);

        setSelectedState(stateName);
        setSelectedStateId(selected?.id || '');
        setStateOfficialAddress(selected?.official_address || '');
    }, [stateNames]);

    const handleEntityChange = useCallback((e) => {
        const entity = e.target.value;
        const entityId = entityNames.find(ent => ent.entity_name === entity)?.id || '';
        setSelectedEntity(entity);
        setSelectedEntityId(entityId);
    }, [entityNames]);

    const benefitList = useMemo(() => [
        'Complimentary compliance reminders',
        'Transparent business formation with no hidden costs',
        'No commitments or subscriptions'
    ], []);

    return (
        <>
            <Helmet>
                <link rel="preload" href={bannerImageUrl} as="image" fetchpriority="high" />
                <meta name="theme-color" content="#ffffff" />
            </Helmet>

            <div className="banner-part">
                <div className="banner-content">
                    <h1>
                        Get Your LLC Up and <span>Running in Minutes</span>
                    </h1>
                    <p>
                        Made by entrepreneurs for entrepreneurs, we've leveled the playing field
                        for side hustlers, innovators, and experienced starters.
                    </p>
                </div>

                <div className="select-part">
                    <div className="select1">
                        <div className="left-entity">
                            <div className="entiity">Entity:</div>
                        </div>
                        <div className="right-select">
                            <select
                                className="form-select"
                                value={selectedEntity}
                                onChange={handleEntityChange}
                                aria-busy={entityNames.length === 0}
                            >
                                <option value="" disabled>Select Entity Type</option>
                                {entityNames.length > 0 ? (
                                    entityNames.map(entity => (
                                        <option key={entity.id} value={entity.entity_name}>
                                            {entity.entity_name}
                                        </option>
                                    ))
                                ) : (
                                    <option value="" disabled>Loading entities...</option>
                                )}
                            </select>
                        </div>
                    </div>

                    <div className="select1">
                        <div className="left-entity">
                            <div className="entiity">State:</div>
                        </div>
                        <div className="right-select">
                            <select
                                className="form-select"
                                value={selectedState}
                                onChange={handleStateChange}
                                aria-busy={stateNames.length === 0}
                            >
                                <option value="" disabled>Choose State of Formation</option>
                                {stateNames.length > 0 ? (
                                    stateNames.map(state => (
                                        <option key={state.id} value={state.state_name}>
                                            {state.state_name}
                                        </option>
                                    ))
                                ) : (
                                    <option value="" disabled>Loading states...</option>
                                )}
                            </select>
                        </div>
                    </div>

                    <div className="packge-btn">
                        <div className="packge-btn1">
                            <Link to="#" onClick={handleViewPackagesClick}>View Packages</Link>
                        </div>
                        <div className="packge-btn2">
                            <Link
                                to={`/form-order?entity=${selectedEntityId}&state=${selectedStateId}`}
                                onClick={() => localStorage.removeItem('formOrderResult')}
                            >
                                START MY BUSINESS
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="banner-bottom-box">
                <div className="box1">
                    {benefitList.map((text, i) => (
                        <div className="box11" key={i}>
                            <div className="box-icon">
                                <img
                                    src="images/Group 11.png"
                                    alt="Icon"
                                    width="24"
                                    height="24"
                                    loading="lazy"
                                />
                            </div>
                            <div className="box-right">
                                <p>{text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div ref={comparisonRef}></div>
        </>
    );
};

export default Banner;
